import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c(VAlert,{attrs:{"dense":"","border":"left","type":"error"}},_vm._l((_vm.errors),function(error,idx){return _c('p',{key:idx,staticClass:"pa-0 ma-0"},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }